import { render, staticRenderFns } from "./BaseConfirm.vue?vue&type=template&id=145f6e58&scoped=true&"
import script from "./BaseConfirm.vue?vue&type=script&lang=ts&"
export * from "./BaseConfirm.vue?vue&type=script&lang=ts&"
import style0 from "./BaseConfirm.vue?vue&type=style&index=0&id=145f6e58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145f6e58",
  null
  
)

export default component.exports